<div class="edit-title-container">
	<form-field-label [labelTranslateKey]="'title'" />

	<mat-form-field class="full-width">
		<input
			maxlength="100"
			matInput
			[formControl]="title"
			[placeholder]="'title' | translate"
			(blur)="titleChanged.emit(title.value)"
		/>
		<mat-hint> *{{ 'required' | translate }} </mat-hint>
		<mat-hint align="end">{{ title.value.length }}/{{ 100 }}</mat-hint>
	</mat-form-field>
</div>
